import { getSum } from '../../../utilities/getSum';
import { checkRangeKind } from './checkRangeKind';
import { mapValues } from './mapValues';
export function updateRangesRelativeValues(spectrum, forceCalculateIntegral = false) {
    const { values, options } = spectrum.ranges;
    const currentSum = getSum(values, 'absolute', checkRangeKind);
    let factor = 0;
    if (options?.sum) {
        if (options.isSumConstant || forceCalculateIntegral) {
            factor = currentSum > 0 ? options.sum / currentSum : 0;
        }
        else if (values?.[0]) {
            const item = values[0];
            factor = (item.integration || options.sum) / item.absolute;
        }
    }
    spectrum.ranges.values = mapValues(values, 'integration', factor, checkRangeKind);
    if (!options.isSumConstant && !forceCalculateIntegral) {
        options.sum = getSum(values, 'integration', checkRangeKind);
    }
}
//# sourceMappingURL=updateRangesRelativeValues.js.map